import { Button, Div, Input, Span, reactive, all } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import Icon from 'components/Icon'
import * as closeIcon from 'icons/close.svg'
import './StudyDetailsPane.scss'
import { activeTab, focusedStudy, focusNextStudy, focusPreviousStudy } from 'model/StudyCollection'
import app from 'app/app'
import { studiesSearch, studySearchCache } from 'model/EvidenceSearch'
import { StudyDetails } from '../extract/ExtractPane'
import { inferExtractState } from 'components/extract/model/extraction'
import * as helpIcon from 'icons/question-circle.svg'
import { screening } from 'model/Screening'
import { track } from 'components/tracking/track'
import { tourRunner } from 'components/entry/Tour'
import { quickAnalysisMap } from 'components/entry/Tour'
import { StudyAnalysisModel } from 'model/AnalyzeStudy'
import { faqMode } from 'model/SearchQuery'

export let studyDetailsPane
export const detailsExpanded = reactive(activeTab == 'screening' || activeTab == 'extract')

const handleEscape = (event) => {
	const detailsPane = document.querySelector('.extract-dialog.study-details-pane')
	if (event.defaultPrevented) {
		return // Do nothing if the event was already processed
	}
	if ((event.key === "Esc") || (event.key === "Escape") && detailsExpanded.valueOf()) {
		detailsExpanded.put(false)
	}
	return
}

export class StudyDetailsPane extends Div('.extract-dialog.study-details-pane', {
	classes: {
		'details-expanded': detailsExpanded,
	}
}) {
	private studyList
	private config
	private studySelectionState

	created(properties) {
		document.addEventListener("keydown", handleEscape);
		this.studySelectionState = reactive()
		this.config = all([focusedStudy, this.studySelectionState], (study, state) => study && ({
			studyDetails: new StudyDetails(study, app.user),
			state
		}))
		let screeningTab = activeTab.valueOf()
		let isScreeningCreated = screening.valueOf()
		let studySelectionState = this.studySelectionState

		const setSelectionState = (study, studySelectionState) => {
			let studyAnalysisModel = new StudyAnalysisModel(study)
			let { currentPublication, outcome } = studyAnalysisModel
			let groups = currentPublication.property('groups')
		
			const extractState = inferExtractState(study, groups, outcome, app.user)
			studySelectionState.put(extractState)
		}

		this.append(Div('.study-details-header', [
			Div('.pane-list-nav.truncate', [
				Button({
					content: '< Previous',
					onclick() {
						let previous = focusPreviousStudy()

						if (activeTab == 'extract' && previous) {
							setSelectionState(previous, studySelectionState)
						}
					},
				}),
				this.config.to(cfg => cfg?.studyDetails.createStudyTitle(cfg.state?.annotate)),
				Button({
					content: 'Next >',
					onclick() {						
						let otherStudy = focusNextStudy()

						if (activeTab == 'extract' && otherStudy) {
							setSelectionState(otherStudy, studySelectionState)
						}
					},
				}),
			]),
			Div('.pane-alt-nav', [ 
				!faqMode ?
					Icon('.help-icon#pane-tour-button', {
						icon: helpIcon,
						title: 'Help',
						onclick() {
							if (activeTab == 'screening') {
								isScreeningCreated ?
									alert('Name: ' + isScreeningCreated.name + ', Description: ' + isScreeningCreated.description)
									: alert('No screening has been started yet')
							} else {
								if (window.confirm('Would you live to view the DocAnalysis tour?')) {
									activeTab.put('sources')
									studyDetailsPane.hide()
									// Navigate to Extract tour component 
									tourRunner(quickAnalysisMap, 0)
								}
							}
						}
					}) : null,
				Icon('.clickable.close-icon', {
					icon: closeIcon,
					title: 'Close this dialog',
					onclick: e => {
						this.hide()
						track({ event: activeTab + '-exit' })
					},
					tabIndex: 0,
				})
			])
		]))
	}
	ready(properties) {
		let weighting = reactive(100)
		this.append(
			Div('.details-body', this.config.to(cfg => {
				if (!cfg) return
				if (!cfg.state) cfg.state = {}
				let { studyDetails, state: { annotate, details, action, effectiveOutcome, groups } } = cfg
				const manage = studyDetails.study.source != 'ClinicalTrials.gov' && studyDetails.study.source != 'EU Clinical Trials'
				const edit = action == 'edit'
				const readonly = annotate == false
				//const onSubmit = readonly ? undefined : () => this.onSubmit()
				const onSubmit = () => this.onSubmit()
				annotate = true
				return studyDetails.createExtractPane(activeTab, {
					annotate,
					details,
					studyList: this.studyList,
					manage,
					//annotate: annotate && !event.shiftKey,
					outcome: edit ? effectiveOutcome.valueOf() : undefined,
					groups: edit ? groups.valueOf() : undefined,
					//debug: event.altKey
					moveToNext: () => {
						focusNextStudy()
					},
					onSubmit
				})
			})
			))
	}
	//
	onSubmit() {
		studySearchCache.clear()
		studiesSearch.updated()
		setTimeout(() => this.hide())
	}

	hide() {
		detailsExpanded.put(false)
	}

	removePane() {
		document.removeEventListener("keydown", handleEscape)
	}

	showStudy(study, state, extract?) {
		focusedStudy.put(study)
		detailsExpanded.put(true)
		this.studySelectionState.put(state)
		if (extract)
			activeTab.put('extract')
	}

}

let includeDropdown = new Dropdown({
	item: [{ content: 'hi' }]
})

let excludeDropdown = new Dropdown({
	item: [{ content: Div('reason to reject') }]
})
studyDetailsPane = new StudyDetailsPane()
